



































import Vue, { PropType } from "vue";
import { Rules } from "@ct/validations";
import { GroupQuery_group_sessions } from "@/graphql/generatedTypes/GroupQuery";
import moment from "moment-timezone";

export default Vue.extend({
  name: "SessionEdit",
  props: {
    session: Object as PropType<GroupQuery_group_sessions>
  },
  methods: {
    formattedInputTime(session: GroupQuery_group_sessions): string | null {
      return moment(session.time || "", "YYYY-MM-DD HH:mm:ss").format("HH:mm");
    },
    ...Rules,
    changeTime(e: string) {
      this.session.time = moment.utc(e, "HH:mm").toISOString();
      this.$emit("session-updated", this.session);
    }
  }
});
